// extracted by mini-css-extract-plugin
module.exports = {"dropdownMenuCaret":"dropdown-menu-caret_dropdownMenuCaret__04qeR"};